// 未到达救援地：已接单、联系车主、前往救援地
const NOT_ARRIVED_STATUS = [2, 11, 22, 23];

export function isNotArrivedOrder(orderInfo) {
    if (!orderInfo) {
        return false;
    }
    return NOT_ARRIVED_STATUS.indexOf(Number(orderInfo.status)) !== -1;
}

export function parseArriveTimeReportSec(orderInfo) {
    if (!orderInfo) {
        return null;
    }
    const val = orderInfo.arrive_time_report;
    if (val === undefined || val === null || String(val).trim() === '') {
        return null;
    }
    const sec = Number(val);
    if (!Number.isFinite(sec)) {
        return null;
    }
    return sec;
}

export function hasArriveTimeReported(orderInfo) {
    return parseArriveTimeReportSec(orderInfo) !== null;
}

export function shouldRemindArriveTime(orderInfo) {
    if (!orderInfo) {
        return false;
    }
    const need = Number(orderInfo.need_arrive_time_report);
    if (!(need > 0)) {
        return false;
    }
    if (hasArriveTimeReported(orderInfo)) {
        return false;
    }
    return isNotArrivedOrder(orderInfo);
}

export function getArriveTimeRemindInterval(orderInfo) {
    const sec = Number(orderInfo && orderInfo.need_arrive_time_report);
    return sec > 0 ? sec * 1000 : 0;
}

export function formatArriveCountdown(remainSec) {
    const sec = Math.max(0, Math.floor(remainSec));
    const h = Math.floor(sec / 3600);
    const m = Math.floor((sec % 3600) / 60);
    const s = sec % 60;
    const pad = (n) => (n < 10 ? '0' + n : String(n));
    return pad(h) + ':' + pad(m) + ':' + pad(s);
}

export function getArriveOvertimeMinutes(remainSec) {
    return Math.max(1, Math.ceil(Math.abs(remainSec) / 60));
}
